import React from "react";

import { useNavigate } from "utils";

import { FarmVerification } from "models";

import { Icon, Typography } from "components";

export const VerifyButton = ({ farm }: { farm: FarmVerification }) => {
  const navigate = useNavigate();

  const buttonData = {
    verify_farm: {
      text: "Verify farm",
      icon: "klim/farm",
      link: "/farm",
    },
    reject_payout: {
      text: "Reject payout",
      icon: "klim/funding-strikethrough",
      link: "",
    },
    verify_fields: {
      text: "Verify fields",
      icon: "klim/field",
      link: "/fields",
    },
    verify_footprinting: {
      text: "Verify footprinting",
      icon: "klim/crop-footprint",
      link: "/footprinting",
    },
    verify_payout: {
      text: "Verify payout",
      icon: "klim/funding",
      link: "",
    },
  };

  const getFarmVerificationStatus = () => {
    const { verified, fieldVerificationsCounts } = farm;

    if (verified === null) {
      return "verify_farm";
    }

    if (verified === false) {
      return "reject_payout";
    }

    if (verified && fieldVerificationsCounts.unverifiedFieldCount > 0) {
      return "verify_fields";
    }

    return "verify_payout";
  };

  const farmVerificationStatus = getFarmVerificationStatus();

  return (
    <div className="pointer farm-list-button" onClick={() => navigate(`/verifications/farms/${farm.id}${buttonData[farmVerificationStatus].link}`)}>
      <div>
        <Icon iconName={buttonData[farmVerificationStatus].icon} className="icon inline" />
        <Typography variant="paragraph-m" color="green-400">
          {buttonData[farmVerificationStatus].text}
        </Typography>
      </div>
      <Icon className="icon inline" iconName="tabler/arrow-right" />
    </div>
  );
};
